var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-2",attrs:{"color":"blue darken-3","dark":"","fab":"","x-small":"","title":"Refresh"},on:{"click":_vm.clickFunction}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("refresh")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }